require('../modules/esnext.set.difference');
require('../modules/esnext.set.intersection');
require('../modules/esnext.set.is-disjoint-from');
require('../modules/esnext.set.is-subset-of');
require('../modules/esnext.set.is-superset-of');
require('../modules/esnext.set.union');
require('../modules/esnext.set.symmetric-difference');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/set-methods.js
// module id = GRZI
// module chunks = 2